/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import Head from "next/head";
// import Image from "next/image";
import Header from "./common/Header";
import Footer from "./common/Footer";
import { useDispatch, useSelector } from "react-redux";
import { gettncData } from "../store/actions/termsConditionAction";
// import { getaboutusData } from "../store/actions/aboutUsAction";


function FunWindowSize() {
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
        function handleResize() {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
      }, []);
      return windowSize;
    }
const termsConditions = () => {
    const size = FunWindowSize();

    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(gettncData());
    }, [dispatch]);
    const tncData = useSelector((state) => state.tnc.tnc.data);
    return (
        
        <div style={{ minHeight: size.height }}>
        <Head>
          <title>Residen | Terms & Conditions</title>
        </Head>
        <Header />
        <div className="innerBannerWrapper">
          <div className="container">
            <div className="innerBannerCaption">
              <h1>{tncData? tncData[0].title: 'Terms & Conditions'}</h1>
              <p>{tncData? tncData[0].meta_description: ''}</p>
            </div>
          </div>
        </div>
        <div className="padding-top padding-bottom aboutusWrapper">
        {(tncData && tncData.length>0) ? <>
          <div className="container cmn-info-style" dangerouslySetInnerHTML={{ __html: tncData[0].content }} />
           </>: null}
        </div>
        <Footer />
      </div>
    );
};

export default termsConditions;